const checkCarIndex = () => import('@/pages/checkCar/checkCarIndex')
const checkCarSearchSaveForm = () => import('@/pages/checkCar/checkCarSearchSaveForm')
const checkCarOrder = () => import('@/pages/checkCar/checkCarOrder')
const checkCarList = () => import('@/pages/checkCar/checkCarList')
const SearchCheckOrder = () => import('@/pages/checkCar/searchCheckOrder')
const checkCarDetail = () => import('@/pages/checkCar/checkCarDetail')
const createCheckOrder = () => import('@/pages/checkCar/createCheckOrder')
export default [{
  path: '/SearchCheckOrder',
  name: 'SearchCheckOrder',
  component: SearchCheckOrder,
  meta: {}
},
{
  path: '/checkCarIndex',
  name: 'checkCarIndex',
  component: checkCarIndex,
  meta: {
    storeKey: 'trs.checkCar.index'
  }
},
{
  path: '/createCheckOrder',
  name: 'createCheckOrder',
  component: createCheckOrder,
  meta: {}
},
{
  path: '/checkCarSearchSaveForm',
  name: 'checkCarSearchSaveForm',
  component: checkCarSearchSaveForm,
  meta: {
  }
},
{
  path: '/checkCarDetail',
  name: 'checkCarDetail',
  component: checkCarDetail,
  meta: {
  }
},
{
  path: '/checkCarList',
  name: 'checkCarList',
  component: checkCarList,
  meta: {}
},
{
  path: '/checkCarOrder',
  name: 'checkCarOrder',
  component: checkCarOrder,
  meta: {}
}
]



// WEBPACK FOOTER //
// ./src/router/checkCar/index.js